import {register} from '../../../../assets/js/modules/eventMap';

const scrollToBottomOnLoad = (el) => (el.scrollTop = el.scrollHeight);

const scrollToLastResponseOnSubmit = () => {
    const lastMsgEl = document.querySelector(
        '[data-kui-chat-message-is-last-response]'
    );

    if (!lastMsgEl) {
        return;
    }

    lastMsgEl.scrollIntoView({behavior: 'smooth'});
};

const chatLog = () => {
    register('chatLog', {scrollToBottomOnLoad});
};

export {chatLog, scrollToLastResponseOnSubmit};
